/* eslint-disable */

/*
	jquery.i4goTrueToken.js

	jQuery plug-in to (hopefully) simplify the i4Go integration process.
	
	DEPENDANCIES:
		jQuery.js version 2.0+

	Copyright (c) 2015 Shift4 Corporation - ALL RIGHTS RESERVED
*/

import jQuery from "jquery";

//	Ensures there will be no 'console is undefined' errors.
window.console = window.console || (function() {
	var c = {};
	c.log = c.warn = c.debug = c.info = c.error = c.time = c.dir = c.profile = c.clear = c.exception = c.trace = c.assert = function(s) {};
	return c;
})();
console = console || window.console;


/*!
 * jQuery postMessage - v0.5 - 9/11/2009
 * http://benalman.com/projects/jquery-postmessage-plugin/
 * 
 * Copyright (c) 2009 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */

// Script: jQuery postMessage: Cross-domain scripting goodness
//
// *Version: 0.5, Last updated: 9/11/2009*
// 
// Project Home - http://benalman.com/projects/jquery-postmessage-plugin/
// GitHub       - http://github.com/cowboy/jquery-postmessage/
// Source       - http://github.com/cowboy/jquery-postmessage/raw/master/jquery.ba-postmessage.js
// (Minified)   - http://github.com/cowboy/jquery-postmessage/raw/master/jquery.ba-postmessage.min.js (0.9kb)
// 
// About: License
// 
// Copyright (c) 2009 "Cowboy" Ben Alman,
// Dual licensed under the MIT and GPL licenses.
// http://benalman.com/about/license/
// 
// About: Examples
// 
// This working example, complete with fully commented code, illustrates one
// way in which this plugin can be used.
// 
// Iframe resizing - http://benalman.com/code/projects/jquery-postmessage/examples/iframe/
// 
// About: Support and Testing
// 
// Information about what version or versions of jQuery this plugin has been
// tested with and what browsers it has been tested in.
// 
// jQuery Versions - 1.3.2
// Browsers Tested - Internet Explorer 6-8, Firefox 3, Safari 3-4, Chrome, Opera 9.
// 
// About: Release History
// 
// 0.5 - (9/11/2009) Improved cache-busting
// 0.4 - (8/25/2009) Initial release

// START: Inline polyfill for IE
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#polyfill
if (typeof Object.assign !== 'function') {
	// Must be writable: true, enumerable: false, configurable: true
	Object.defineProperty(Object, "assign", {
	  value: function assign(target, varArgs) { // .length of function is 2
		'use strict';
		if (target === null || target === undefined) {
		  throw new TypeError('Cannot convert undefined or null to object');
		}
  
		var to = Object(target);
  
		for (var index = 1; index < arguments.length; index++) {
		  var nextSource = arguments[index];
  
		  if (nextSource !== null && nextSource !== undefined) {
			for (var nextKey in nextSource) {
			  // Avoid bugs when hasOwnProperty is shadowed
			  if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
				to[nextKey] = nextSource[nextKey];
			  }
			}
		  }
		}
		return to;
	  },
	  writable: true,
	  configurable: true
	});
  }

  
if (!String.prototype.startsWith) {
    Object.defineProperty(String.prototype, 'startsWith', {
        value: function(search, rawPos) {
            var pos = rawPos > 0 ? rawPos|0 : 0;
            return this.substring(pos, pos + search.length) === search;
        }
    });
}

// END: Inline polyfill for IE



(function($) {
	'$:nomunge'; // Used by YUI compressor.

	// A few vars used in non-awesome browsers.
	var interval_id,
		last_hash,
		cache_bust = 1,

		// A var used in awesome browsers.
		rm_callback,

		// A few convenient shortcuts.
		// window = this, // Removing this property 'this' is undefined for ES6 strict javascript
		FALSE = !1,

		// Reused internal strings.
		postMessage = 'postMessage',
		addEventListener = 'addEventListener',

		p_receiveMessage,

		// I couldn't get window.postMessage to actually work in Opera 9.64!
		has_postMessage = window[postMessage]; // && !$.browser.opera;

	// Method: jQuery.postMessage
	// 
	// This method will call window.postMessage if available, setting the
	// targetOrigin parameter to the base of the target_url parameter for maximum
	// security in browsers that support it. If window.postMessage is not available,
	// the target window's location.hash will be used to pass the message. If an
	// object is passed as the message param, it will be serialized into a string
	// using the jQuery.param method.
	// 
	// Usage:
	// 
	// > jQuery.postMessage( message, target_url [, target ] );
	// 
	// Arguments:
	// 
	//  message - (String) A message to be passed to the other frame.
	//  message - (Object) An object to be serialized into a params string, using
	//    the jQuery.param method.
	//  target_url - (String) The URL of the other frame this window is
	//    attempting to communicate with. This must be the exact URL (including
	//    any query string) of the other window for this script to work in
	//    browsers that don't support window.postMessage.
	//  target - (Object) A reference to the other frame this window is
	//    attempting to communicate with. If omitted, defaults to `parent`.
	// 
	// Returns:
	// 
	//  Nothing.

	$[postMessage] = function(message, target_url, target) {
		if (!target_url) {
			return;
		}

		// Serialize the message if not a string. Note that this is the only real
		// jQuery dependency for this script. If removed, this script could be
		// written as very basic JavaScript.
		message = typeof message === 'string' ? message : $.param(message);

		// Default to parent if unspecified.
		target = target || parent;

		if (has_postMessage) {
			// The browser supports window.postMessage, so call it with a targetOrigin
			// set appropriately, based on the target_url parameter.
			target[postMessage](message, target_url.replace(/([^:]+:\/\/[^\/]+).*/, '$1'));

		} else if (target_url) {
			// The browser does not support window.postMessage, so set the location
			// of the target to target_url#message. A bit ugly, but it works! A cache
			// bust parameter is added to ensure that repeat messages trigger the
			// callback.
			target.location = target_url.replace(/#.*$/, '') + '#' + (+new Date) + (cache_bust++) + '&' + message;
		}
	};

	// Method: jQuery.receiveMessage
	// 
	// Register a single callback for either a window.postMessage call, if
	// supported, or if unsupported, for any change in the current window
	// location.hash. If window.postMessage is supported and source_origin is
	// specified, the source window will be checked against this for maximum
	// security. If window.postMessage is unsupported, a polling loop will be
	// started to watch for changes to the location.hash.
	// 
	// Note that for simplicity's sake, only a single callback can be registered
	// at one time. Passing no params will unbind this event (or stop the polling
	// loop), and calling this method a second time with another callback will
	// unbind the event (or stop the polling loop) first, before binding the new
	// callback.
	// 
	// Also note that if window.postMessage is available, the optional
	// source_origin param will be used to test the event.origin property. From
	// the MDC window.postMessage docs: This string is the concatenation of the
	// protocol and "://", the host name if one exists, and ":" followed by a port
	// number if a port is present and differs from the default port for the given
	// protocol. Examples of typical origins are https://example.org (implying
	// port 443), http://example.net (implying port 80), and http://example.com:8080.
	// 
	// Usage:
	// 
	// > jQuery.receiveMessage( callback [, source_origin ] [, delay ] );
	// 
	// Arguments:
	// 
	//  callback - (Function) This callback will execute whenever a <jQuery.postMessage>
	//    message is received, provided the source_origin matches. If callback is
	//    omitted, any existing receiveMessage event bind or polling loop will be
	//    canceled.
	//  source_origin - (String) If window.postMessage is available and this value
	//    is not equal to the event.origin property, the callback will not be
	//    called.
	//  source_origin - (Function) If window.postMessage is available and this
	//    function returns false when passed the event.origin property, the
	//    callback will not be called.
	//  delay - (Number) An optional zero-or-greater delay in milliseconds at
	//    which the polling loop will execute (for browser that don't support
	//    window.postMessage). If omitted, defaults to 100.
	// 
	// Returns:
	// 
	//  Nothing!

	$.receiveMessage = p_receiveMessage = function(callback, source_origin, delay) {
		if (has_postMessage) {
			// Since the browser supports window.postMessage, the callback will be
			// bound to the actual event associated with window.postMessage.

			if (callback) {
				// Unbind an existing callback if it exists.
				rm_callback && p_receiveMessage();

				// Bind the callback. A reference to the callback is stored for ease of
				// unbinding.
				rm_callback = function(e) {
					if ((typeof source_origin === 'string' && e.origin !== source_origin) ||
						($.isFunction(source_origin) && source_origin(e.origin) === FALSE)) {
						return FALSE;
					}
					callback(e);
				};
			}

			if (window[addEventListener]) {
				window[callback ? addEventListener : 'removeEventListener']('message', rm_callback, FALSE);
			} else {
				window[callback ? 'attachEvent' : 'detachEvent']('onmessage', rm_callback);
			}

		} else {
			// Since the browser sucks, a polling loop will be started, and the
			// callback will be called whenever the location.hash changes.

			interval_id && clearInterval(interval_id);
			interval_id = null;

			if (callback) {
				delay = typeof source_origin === 'number' ?
					source_origin :
					typeof delay === 'number' ?
					delay :
					100;

				interval_id = setInterval(function() {
					var hash = document.location.hash,
						re = /^#?\d+&/;
					if (hash !== last_hash && re.test(hash)) {
						last_hash = hash;
						callback({
							data: hash.replace(re, '')
						});
					}
				}, delay);
			}
		}
	};

})(jQuery);

/*
 * END OF jQuery postMessage
 */


/*
 *	Shift4 i4Go stuff starts here.
 */
(function(factory) {
	if (typeof define === "function" && define.amd) {
		define(["jquery"], factory);
	} else {
		factory(jQuery);
	}
}(function($) {

	$.extend($.fn, {
		i4goTrueToken: function(options) {

			// if nothing is selected, return nothing; can't chain anyway
			if (!this.length) {
				console.warn("i4goTrueToken - Nothing selected; can't create iframe and linkage; returning nothing.");
				return;
			}

			// check if a validator for this form was already created
			var i4goTrueTokenFramer = $.data(this[0], "i4goTrueTokenFramer");
			if (i4goTrueTokenFramer) {
				return i4goTrueTokenFramer;
			}

			i4goTrueTokenFramer = new $.i4goTrueTokenFramer(options, this[0]);
			$.data(this[0], "i4goTrueTokenFramer", i4goTrueTokenFramer);

			return i4goTrueTokenFramer;
		}
	});

	// constructor for validator
	$.i4goTrueTokenFramer = function(options, form) {
		this.settings = Object.assign({}, $.i4goTrueTokenFramer.defaults, options);
		this.walletConfig = null;
		this.basket = null;
		this.form = form;
		this.tranUUID = "";
		this.init();
	};

	// the beast
	$.extend($.i4goTrueTokenFramer, {

		defaults: {
			server: "", // REQUIRED from access.i4go.com call (or i4access.shift4test.com)
			accessBlock: "", // REQUIRED from access.i4go.com call (or i4access.shift4test.com)
			self: "", // REQUIRED - the full URL used to located the current page - MUST MATCH EXACTLY INCLUDING QUERY PARAMETERS - document.location should work
			template: "bootstrap3-horizontal",
			language: "en",

			url: "", // If not provided (the default), value will be calculated based on the server value provided

			frameContainer: "i4goFrame", // Only used if frameName does not exist
			frameName: "", // Auto-assigned if left empty
			frameAutoResize: true,
			frameClasses: "",

			// Auto populated form fields. Precedence: field name, field id
			formPaymentResponse: "i4go_response",
			formPaymentResponseCode: "i4go_responsecode",
			formPaymentResponseText: "i4go_responsetext",
			formPaymentMaskedCard: "i4go_maskedcard",
			formPaymentToken: "i4go_uniqueid",
			formPaymentExpMonth: "i4go_expirationmonth",
			formPaymentExpYear: "i4go_expirationyear",
			formPaymentType: "i4go_cardtype",
			formStreetAddress: "i4go_streetaddress",
			formPostalCode: "i4go_postalcode",
			formCardholderName: "i4go_cardholdername",
			formMetaToken: "i4go_metatoken",
			formExtendedCardData: "i4go_extendedcarddata",
			formUToken: "i4go_utoken",
			formApplePayToken: "i4go_applepaytoken",
			formGooglePayToken: "i4go_googlepaytoken",
			formSignedData: "i4go_signeddata",
			formAutoSubmitOnSuccess: false,
			formAutoSubmitOnFailure: false,
			gcDisablesExpiration: false,
			gcDisablesCVV2Code: false,

			// Events
			onSuccess: function(form, data) {
				//console.log("i4goTrueToken - onSuccess()",data);
			},
			onFailure: function(form, data) {
				//console.warn("i4goTrueToken - onFailure()",data);
			},
			onComplete: function(form, data) {
				//console.log("i4goTrueToken - onComplete()",data);
			},

			acceptedPayments: "AX,DC,GC,JC,MC,NS,VS",

			i4goInfo: {
				visible: false
			},

			// card swipe capabilities
			encryptedOnlySwipe: true, // false allows for non-encrypted swipes - not recommended

			// wallet support - apple and google pay
			walletsEnabled: false, // this overrides automatically based on the inclusion of wallets.js
			wallet: {
				activeCardRequired: false,
				nameRequired: null, // true/false/null - null uses addressRequired
				addressRequired: false,
				emailRequired: false,
				phoneNumberRequired: false,
				allowedCountryCodes: [],
				shippingOptionRequired: false,
				shippingOptions: [], // first option will be the default
				shippingType: "shipping", // shipping, delivery, storePickup, servicePickup - Apple Pay only?

				// For the following button attributes, see google documentation - empty=default
				buttonColor: "", // default: A Google-selected default value. Currently black but it may change over time (default).
				// black: A black button suitable for use on white or light backgrounds.
				// white: A white button suitable for use on colorful backgrounds.
				buttonType: "", // buy: "Buy with Google Pay" button (default).
				// donate: "Donate with Google Pay" button.
				// plain: Google Pay button without additional text.
				// translated button label may appear if a language specified in the viewer's browser matches an available language.
				buttonSizeMode: "", // static: Button has a static width and height (default).
				// fill: Button size changes to fill the size of its container.
				buttonRootNode: "", // HTMLDocument or ShadowRoot
				paymentInitiatedEvent: function() {}, // CBS added setting to execute preprocessing action like blocking the UI to prevent user from clicking the button again.
				paymentErrorEvent: function() {}  // CBS added setting to execute action when an error occured or when user exits the google pay dialog like unblocking the UI to allow user to interact with the page again. 
            },
			onWalletEnabled: function(wallet) {
				// wallet: string, apple-pay, google-pay
				// DEPRICATED - use onWalletInit instead
				console.log("i4goTrueToken - onWalletEnabled()", wallet);
			},
			onWalletInit: function(wallet, enabled, reason) {
				// wallet: string, apple-pay, google-pay
				// enabled: boolean, true or false
				// reason: text description, reason for disabled
				console.log("i4goTrueToken - onWalletInit()", wallet, enabled, reason);
			},
			/**
			 * Handles dynamic buy flow shipping address and shipping options callback intents. Note, this Shift4 implimentation of this callback differs slightly
			 * from the native google implimentiation in two aspects:
			 *		1)	The @intermediatePaymentData passed has already gone through the default behaviour of the Shift4 wallet library. This result can be modified
			 *			further are recreated from scratch.
			 *		2)	The Shift4 wallet library is handling the promise layer. Simply return the final @intermediatePaymentData.
			 *
			 * @param {object} iobj - i4goTrueToken instance
			 * @param {object} itermediatePaymentData response from Google Pay API a shipping address or shipping option is selected in the payment sheet.
			 * @param {object} paymentDataRequestUpdate response created by Shift4 wallet default behaviour.
			 * @see {@link https://developers.google.com/pay/api/web/reference/response-objects#IntermediatePaymentData|IntermediatePaymentData object reference}
			 *
			 * @see {@link https://developers.google.com/pay/api/web/reference/response-objects#PaymentDataRequestUpdate|PaymentDataRequestUpdate}
			 * @returns intermediatePaymentData<{object}> to update the payment sheet.
			 */
			onPaymentDataChanged: null,
			/*
			function( iobj, intermediatePaymentData, paymentDataRequestUpdate ){
				//console.log("i4goTrueToken - onPaymentDataChanged()",intermediatePaymentData);
				return paymentDataRequestUpdate;
			},
			*/

			// Debug flags: Simply creates additional console log messages so a debugger needs to be running to view. In no event does CHD get logged.
			debug: false, // Parent side
			remoteDebug: false // Adds width indicators within the iframe contents to help with frame sizing
		},

		// http://jqueryvalidation.org/jQuery.validator.setDefaults/
		setDefaults: function(settings) {
			return Object.assign($.i4goTrueTokenFramer.defaults, settings);
		},

		applyDefaults: function(settings) {
			return Object.assign({}, $.i4goTrueTokenFramer.defaults, settings);
		},

		shippingItemDefaults: {
			id: "", //"shipping-001",
			label: "", //"Free: Standard shipping",
			description: "", //"Free Shipping delivered in 5 business days."
			price: 0.00
		},

		setShippingItemDefaults: function(item) {
			return Object.assign($.i4goTrueTokenFramer.shippingItemDefaults, item);
		},

		applyShippingItemDefaults: function(item) {
			return Object.assign({}, $.i4goTrueTokenFramer.shippingItemDefaults, item);
		},

		cartItemDefaults: {
			name: "",
			sku: "",
			quantity: 1,
			description: "",
			price: 0.00
		},

		setCartItemDefaults: function(item) {
			return Object.assign($.i4goTrueTokenFramer.cartItemDefaults, item);
		},

		applyCartItemDefaults: function(item) {
			return Object.assign({}, $.i4goTrueTokenFramer.cartItemDefaults, item);
		},

		prototype: {

			init: function() {
				this.settings.walletsEnabled = (typeof i4goWalletsInit === "function");
				var myself = this,
					err = [];

				if (this.settings.debug) {
					console.log("i4goTrueToken - init()", this.settings);
				}

				if (!this.settings.frameContainer.trim().length) {
					var msg = "Usage Error: i4goTrueToken - frameContainer name not provided.";
					console.error(msg);
					err.push(msg);
				}

				if (this.settings.frameContainer.trim().length) {
					this.container = $("#" + this.settings.frameContainer.trim());
					if (!this.container.length) {
						// container not provided so we'll prepend it to the form -- hopefully form is located in the correct position on the page!
						if (this.settings.debug) {
							console.log("i4goTrueToken - iframe container div '" + this.settings.frameContainer + "' not provided -- inserting a default container into form.");
						}
						$(this.currentForm).prepend("<div id='" + this.settings.frameContainer + "'></div>");
						this.container = $("#" + this.settings.frameContainer.trim());
					}
					if (!this.container.length) {
						var msg = "Usage Error: i4goTrueToken - iframe container div '" + this.settings.frameContainer + "' not provided";
						console.error(msg);
						err.push(msg);
					}
				}
				if (!this.settings.server.trim().length) {
					var msg = "Usage Error: i4goTrueToken - server not provided";
					console.error(msg);
					err.push(msg);
				}
				if (!this.settings.accessBlock.trim().length) {
					var msg = "Usage Error: i4goTrueToken - accessBlock not provided";
					console.error(msg);
					err.push(msg);
				}
				if (this.settings.self.href && (typeof this.settings.self.href === 'string')) {
					// set to string property (IE fix)
					this.settings.self = this.settings.self.href;
				}
				if (!this.settings.self.trim().length) {
					var msg = "Usage Error: i4goTrueToken - self not provided";
					console.error(msg);
					err.push(msg);
				}
				if (err.length) {
					// can't do anything more for this poor unfortunate sole -- simply return.
					alert(err.toString());
					return;
				}

				if (!this.settings.url.trim().length) {
					// Set url based on value of server
					this.settings.url = "https://i4m.i4go.com"; // default to production
					if (this.settings.server.search(/i4go\-payment\.shift4test\.com/i) >= 0) {
						this.settings.url = "https://i4m.shift4test.com"; // testing/certify
					} else
					if (this.settings.server.search(/wh\-i4go\.s4-test\.com/i) >= 0) {
						this.settings.url = "https://wh-i4m.s4-test.com"; // internal s4-test
					} else
					if (this.settings.server.search(/th\-i4go\d\d\.shift4\.com/i) >= 0) {
						this.settings.url = "http://th-i4m.s4-test.com"; // trailerhood
					}
					if (myself.settings.debug) {
						console.log("i4goTrueToken - i4m calculation:", this.settings.url);
					}
				}

				// Setup interframe communication.
				this.src = this.settings.url + "/index.cfm?fuseaction=get.token&i4go_server=" + encodeURIComponent(this.settings.server) + "&i4go_accessBlock=" + encodeURIComponent(this.settings.accessBlock) + "&i4go_template=" + encodeURIComponent(this.settings.template) + "&i4go_language=" + encodeURIComponent(this.settings.language) + "&i4go_self=" + encodeURIComponent(this.settings.self);
				$.receiveMessage(
					function(e) {
						if (myself.settings.debug) {
							console.log("i4goTrueToken - MESSAGE RECEIVED:", e);
						}
						myself.callback(e.data);
					},
					this.settings.url.replace(/([^:]+:\/\/[^\/]+).*/, '$1')
				);

				// setup frame
				var classes = " class='i4go-frame" + (this.settings.frameClasses === "" ? "" : " " + this.settings.frameClasses) + "'";
				this.frameName = "i4goTT_" + this.generateUUID();
				this.container.html("<iframe id='" + this.frameName + "' name='" + this.frameName + "' src='" + this.src + "' frameBorder='0' width='100%' height='100%' scrolling='no' " + classes + "></iframe>");
			},

			callback: function(data) {
				if (this.settings.debug) {
					console.log("i4goTrueToken - callback() settings:", this.settings);
					console.log("i4goTrueToken - callback() BEGIN:", data);
				}
				try {
					var isValid = false;
					try {
						data = JSON.parse(data);
						isValid = (typeof data == "object") && (typeof data.action == "string");
					} catch (e) {
						// ignoring - assume not for us - apple bug that sends messages destined for other processes
					}
					if (isValid) {
						if (data.action) {
							switch (data.action) {
								case 'basket':
									this.setBasket(data);
									break;
								case 'clear':
									this.clearFormValues();
									break;
								case 'get':
									this.sendFormValuesToFrame();
									break;
								case 'resize':
									this.resize(data);
									break;
								case 'set':
									this.setFormValues(data);
									break;
								case 'settings':
									this.sendSettingsToFrame();
									break;
								case 'test':
									this.test(data);
									break;
								case 'tranUUID':
									this.setTranUUID(data);
									break;
								default:
									console.warn("i4goTrueToken - callback() called with unknown action value: " + data.action);
							}
						}
					}
				} catch (err) {
					remoteLog("i4goTrueToken - callback() error: " + err.message + " (" + JSON.stringify(data) + ")");
					console.warn("i4goTrueToken - callback() error: " + err.message, data);
				}
				if (this.settings.debug) {
					console.log("i4goTrueToken - callback() END:", data);
				}
			},

			getField: function(name) {
				var str = "[name='" + name + "']",
					result = $(this.form).find(str);
				if (!result.length) {
					result = $("#" + name);
				}
				if (this.settings.debug) {
					console.log("i4goTrueToken - getField('" + str + "')=" + (result.length ? "found" : "NOT FOUND"));
				}
				return result;
			},

			clear: function() {
				var frame = $("#" + this.frameName)[0],
					data = JSON.stringify({
						action: 'clear'
					});
				if (this.settings.debug) {
					console.log("i4goTrueToken - clear():", data);
				}
				$.postMessage(data, this.src, frame.contentWindow);
				this.clearFormValues();
			},

			clearFormValues: function() {
				if (this.settings.debug) {
					console.log("i4goTrueToken - clearFormValues()");
				}
				this.getField(this.settings.formPaymentResponse).val("");
				this.getField(this.settings.formPaymentResponseCode).val("");
				this.getField(this.settings.formPaymentResponseText).val("");
				this.getField(this.settings.formPaymentToken).val("");
				this.getField(this.settings.formPaymentExpMonth).val("");
				this.getField(this.settings.formPaymentExpYear).val("");
				this.getField(this.settings.formPaymentType).val("");
				this.getField(this.settings.formCardholderName).val("");
				this.getField(this.settings.formStreetAddress).val("");
				this.getField(this.settings.formPostalCode).val("");
				this.getField(this.settings.formMetaToken).val("");
				this.getField(this.settings.formApplePayToken).val("");
				this.getField(this.settings.formGooglePayToken).val("");
			},

			generateUUID: function() {
				var d = new Date().getTime();
				var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
					var r = (d + Math.random() * 16) % 16 | 0;
					d = Math.floor(d / 16);
					return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
				});
				return uuid;
			},

			onWalletEnabled: function(wallet, enabled, reason) {
				if (typeof enabled == "undefined") {
					enabled = true;
				}
				if (typeof reason == "undefined") {
					reason = "OK";
				}
				(this.settings.debug) && console.log("i4goTrueToken - onWalletEnabled()", wallet, enabled, reason);
				if (typeof this.settings.onWalletInit == "function") {
					this.settings.onWalletInit(wallet, enabled, reason);
				}
				if (enabled && (typeof this.settings.onWalletEnabled == "function")) {
					this.settings.onWalletEnabled(wallet);
				}
			},

			propExists: function(obj, prop) {
				var parts = prop.split('.');
				for (var i = 0, l = parts.length; i < l; i++) {
					var part = parts[i];
					if (obj !== null && typeof obj === "object" && part in obj) {
						obj = obj[part];
					} else {
						return false;
					}
				}
				return true;
			},

			remoteLog: function(msg) {
				var frame = $("#" + this.frameName)[0],
					data = JSON.stringify({
						action: 'remoteLog',
						msg: msg
					});
				$.postMessage(data, this.src, frame.contentWindow);
			},

			resize: function(data) {
				this.settings.debug && console.log("i4goTrueToken - resize()", data);
				if (this.settings.frameAutoResize) {
					$("#" + this.frameName).css({"height":"auto","min-height":"190px"});
				}
			},

			sendApplePayToFrame: function(paymentToken) {
				var frame = $("#" + this.frameName)[0],
					data = JSON.stringify({
						action: 'apple-pay',
						paymentToken: paymentToken
					});
				this.settings.debug && console.log("i4goTrueToken - sendApplePayToFrame()");
				$.postMessage(data, this.src, frame.contentWindow);
				this.clearFormValues();
			},

			sendGooglePayToFrame: function(paymentToken) {
				var frame = $("#" + this.frameName)[0],
					data = JSON.stringify({
						action: 'google-pay',
						paymentToken: paymentToken
					});
				this.settings.debug && console.log("i4goTrueToken - sendGooglePayToFrame()");
				$.postMessage(data, this.src, frame.contentWindow);
				this.clearFormValues();
			},

			sendFormValuesToFrame: function() {
				this.settings.debug && console.log("i4goTrueToken - getFormValues()");
				return {
					i4go_uniqueid: this.getFieldVal(this.settings.formToken, ""),
					i4go_expirationmonth: this.getFieldVal(this.settings.formExpMonth, ""),
					i4go_expirationyear: this.getFieldVal(this.settings.formExpYear, ""),
					i4go_cardtype: this.getFieldVal(this.settings.formPaymentType, ""),
					i4go_cardholdername: this.getFieldVal(this.settings.formCardholderName, ""),
					i4go_streetaddress: this.getFieldVal(this.settings.formStreetAddress, ""),
					i4go_postalcode: this.getFieldVal(this.settings.formPostalCode, ""),
					i4go_metatoken: this.getFieldVal(this.settings.formMetaToken, ""),
					i4go_extendedCardData: this.getFieldVal(this.settings.formExtendedCardData, ""),
					i4go_utoken: this.getFieldVal(this.settings.formUToken, "")
				};
			},

			sendSettingsToFrame: function() {
				var frame = $("#" + this.frameName)[0],
					data = JSON.stringify({
						action: 'settings',
						settings: this.settings
					});
				this.settings.debug && console.log("i4goTrueToken - sendSettingsToFrame():", data, this.settings);
				$.postMessage(data, this.src, frame.contentWindow);
			},

			// this function expects a cardswipe result structure
			sendSwipeToFrame: function(data) {
				var frame = $("#" + this.frameName)[0],
					data = JSON.stringify({
						action: 'swipe',
						swipe: data
					});
				this.settings.debug && console.log("i4goTrueToken - sendSwipeToFrame()");
				$.postMessage(data, this.src, frame.contentWindow);
				this.clearFormValues();
			},

			setBasket: function(data) {
				this.settings.debug && console.log("i4goTrueToken - setBasket()", data, this.settings);
				this.walletConfig = data.response.walletConfig;
				this.basket = data.response.basket;
				if (this.settings.walletsEnabled) {
					i4goWalletsInit(this);
				}
			},

			setFormValues: function(data) {
				this.settings.debug && console.log("i4goTrueToken - setFormValues()", data);

				// Default all missing properties.
				var props = [
					"i4go_response",
					"i4go_responsecode",
					"i4go_responsetext",
					"i4go_uniqueid",
					"i4go_expirationmonth",
					"i4go_expirationyear",
					"i4go_cardtype",
					"i4go_cardholdername",
					"i4go_streetaddress",
					"i4go_postalcode",
					"i4go_metatoken",
					"i4go_extendedcarddata",
					"i4go_utoken",
					"i4go_applepaytoken",
					"i4go_googlepaytoken",
					"i4go_signeddata"
				];
				for (var i = 0, l = props.length; i < l; i++) {
					var prop = props[i];
					if (!this.propExists(data.response, prop)) {
						data.response[prop] = "";
					}
				}

				// Now do the actual setting.
				this.clearFormValues();
				this.getField(this.settings.formPaymentResponse).val(data.response.i4go_response);
				this.getField(this.settings.formPaymentResponseCode).val(data.response.i4go_responsecode);
				this.getField(this.settings.formPaymentResponseText).val(data.response.i4go_responsetext);
				this.getField(this.settings.formPaymentToken).val(data.response.i4go_uniqueid);
				this.getField(this.settings.formPaymentExpMonth).val(data.response.i4go_expirationmonth);
				this.getField(this.settings.formPaymentExpYear).val(data.response.i4go_expirationyear);
				this.getField(this.settings.formPaymentType).val(data.response.i4go_cardtype);
				this.getField(this.settings.formCardholderName).val(data.response.i4go_cardholdername);
				this.getField(this.settings.formStreetAddress).val(data.response.i4go_streetaddress);
				this.getField(this.settings.formPostalCode).val(data.response.i4go_postalcode);
				this.getField(this.settings.formMetaToken).val(data.response.i4go_metatoken);
				this.getField(this.settings.formExtendedCardData).val(data.response.i4go_extendedcarddata);
				this.getField(this.settings.formUToken).val(data.response.i4go_utoken);
				this.getField(this.settings.formApplePayToken).val(data.response.i4go_applepaytoken);
				this.getField(this.settings.formGooglePayToken).val(data.response.i4go_googlepaytoken);
				this.getField(this.settings.formSignedData).val(data.response.i4go_signeddata);
				if (data.response.i4go_uniqueid.length >= 4) {
					this.getField(this.settings.formPaymentMaskedCard).val("********" + data.response.i4go_uniqueid.substring(0, 4));
				}

				if (typeof data.response.i4go_applepaytoken === "string" && data.response.i4go_applepaytoken.length) {
					this.getField(this.settings.formApplePayToken).val(data.response.i4go_applepaytoken);
					data.response.i4go_applepaytoken = JSON.parse(data.response.i4go_applepaytoken);
				}
				if (typeof data.response.i4go_googlepaytoken === "string" && data.response.i4go_googlepaytoken.length) {
					this.getField(this.settings.formGooglePayToken).val(data.response.i4go_googlepaytoken);
					data.response.i4go_googlepaytoken = JSON.parse(data.response.i4go_googlepaytoken);
				}

				if (this.settings.walletsEnabled) {
					postWalletComplete(data.response.i4go_response === "SUCCESS");
				}
				if (data.response.i4go_response === "SUCCESS") {
					if (this.settings.onSuccess) {
						this.settings.onSuccess(this.form, data.response);
					}
					if (this.settings.onComplete) {
						this.settings.onComplete(this.form, data.response);
					}
					if (this.settings.formAutoSubmitOnSuccess) {
						this.form.submit();
					}
				}
				if (data.response.i4go_response === "FAILURE") {
					if (this.settings.onFailure) {
						this.settings.onFailure(this.form, data.response);
					}
					if (this.settings.onComplete) {
						this.settings.onComplete(this.form, data.response);
					}
					if (this.settings.formAutoSubmitOnFailure) {
						this.form.submit();
					}
				}
			},

			submit: function() {
				var frame = $("#" + this.frameName)[0],
					data = JSON.stringify({
						action: 'submit'
					});
				this.settings.debug && console.log("i4goTrueToken - submit():", data);
				$.postMessage(data, this.src, frame.contentWindow);
			},

			test: function() {
				console.log("i4goTrueToken - test()");
				console.log("arguments.length=" + arguments.length);
				for (var i = 0; i < arguments.length; i++) {
					console.log("arguments[" + i + "]=" + arguments[i]);
				}
				this.clearFormValues();
				this.setFormValues({
					i4go_response: "SUCCESS",
					i4go_responsecode: "1",
					i4go_uniqueid: "2222xxxxxxxxxxxx",
					i4go_expirationmonth: "12",
					i4go_expirationyear: "2020",
					i4go_cardtype: "VS"
				});
			},

			setTranUUID: function(data) {
				this.settings.debug && console.log("i4goTrueToken - tranUUID()", data);
				if (typeof data === "string" && data.length) {
					this.tranUUID = data;
				}
			}
		}

	});

}));

// Note: When updating this script with an updated copy from https://i4m.i4go.com/js/wallets.js, remember to add the following:
// 1. Add import $ from "jquery"
// 2. Change instances where wallet settings expected type to be "object" when it should be string. Example:
//		From: if (typeof _wallets_i4goTrueTokenObj.settings.wallet.buttonColor === "object")
//		To: if (typeof _wallets_i4goTrueTokenObj.settings.wallet.buttonColor === "string")
// 3. Add the following wallet settings and call in onGooglePaymentButtonClicked. These functions are used to block/unblock the UI
//		so that user won't be able to press the Google Pay button again when payment is in progress.
//		wallets: {
//			paymentInitiatedEvent,
//			paymentErrorEvent
//		}

import $ from "jquery";

// wallets.js
//
// I am the js code executed for wallets.

var _wallets_canMakeApplePayments = false;
var _wallets_i4goTrueTokenObj = null;
var _wallet_session = null;

$(function () {
	$(".pay-button").hide().addClass("hidden").addClass("pay-hidden");
});

function i4goWalletsInit(owner) {
	_wallets_i4goTrueTokenObj = owner;
	_wallets_i4goTrueTokenObj.settings.debug && remoteLog("Wallets initializing...");
	$(".pay-button").hide().addClass("hidden").addClass("pay-hidden");
	if ((typeof _wallets_i4goTrueTokenObj.walletConfig === "object")) {
		applePayInit(_wallets_i4goTrueTokenObj.walletConfig);
		googlePayInit(_wallets_i4goTrueTokenObj.walletConfig);
		_wallets_i4goTrueTokenObj.settings.debug && remoteLog("Wallets initialized");
	} else {
		var reason = "Wallets not enabled";
		_wallets_i4goTrueTokenObj.settings.debug && remoteLog(reason);
		_wallets_i4goTrueTokenObj.onWalletEnabled("apple-pay", false, reason);
		_wallets_i4goTrueTokenObj.onWalletEnabled("google-pay", false, reason);
	}
}

function postWalletComplete(success) {
	if (_wallet_session != null) {
		_wallet_session.success = success;
		switch (_wallet_session.wallet) {
			case 'apple':
				postApplePayComplete(success);
				break;
			case 'google':
				postGooglePayComplete(success);
				break;
		}
	}
}

function remoteLog(msg, doConsoleLog) {
	if (_wallets_i4goTrueTokenObj !== null && typeof _wallets_i4goTrueTokenObj.walletConfig === "object") {
		_wallets_i4goTrueTokenObj.remoteLog("(Wallets) " + msg);
	}
	if (typeof doConsole == null || doConsoleLog) {
		console.log("wallets - " + msg);
	}
	return true;
}



/*
 **
 ** Apple Pay
 **
 */

function applePayInit(config) {
	try {
		_wallets_i4goTrueTokenObj.settings.debug && remoteLog("Checking for Apple Pay...");
		if ((typeof config === "object") &&
			(typeof config.applePay === "object") &&
			(typeof config.applePay.merchantIdentifier === "string") &&
			config.applePay.merchantIdentifier.length) {
			if (window.ApplePaySession && ApplePaySession.supportsVersion(3) && ApplePaySession.canMakePayments()) {
				if (_wallets_i4goTrueTokenObj.settings.wallet.activeCardRequired) {

					var id = config.applePay.merchantIdentifier;
					if (typeof config.merchant !== "undefined" && typeof config.merchant.verified !== "undefined" && config.merchant.verified) {
						id = config.applePay.partnerInternalMerchantIdentifier;
					}
					var promise = ApplePaySession.canMakePaymentsWithActiveCard(id);
					promise.then(function (canMakePayments) {
						_wallets_i4goTrueTokenObj.settings.debug && remoteLog("applePayInit.canMakePaymentsWithActiveCard(" + id + "): " + canMakePayments);
						_wallets_canMakeApplePayments = canMakePayments;

						/* This is idential to block with activeCardRequired */
						if (canMakePayments) {
							$(".apple-pay-button").on("click", onApplePayClick);
							$(".apple-pay-button").show().removeClass("hidden").removeClass("pay-hidden");
							$(".apple-pay-button").removeClass("no-apple-pay");
							$(".apple-pay-button-container").removeClass("disabled-image");
							_wallets_i4goTrueTokenObj.onWalletEnabled("apple-pay", true, "Ready");
						}
					}, function (error) {
						var reason = "applePayInit Error: " + error.message;
						console.error(error);
						remoteLog(reason, false);
						_wallets_i4goTrueTokenObj.onWalletEnabled("apple-pay", false, reason);
					});
				} else {
					/* Similar to above */
					_wallets_canMakeApplePayments = true;
					$(".apple-pay-button").on("click", onApplePayClick);
					$(".apple-pay-button").show().removeClass("hidden").removeClass("pay-hidden");
					$(".apple-pay-button").removeClass("no-apple-pay");
					$(".apple-pay-button-container").removeClass("disabled-image");
					_wallets_i4goTrueTokenObj.onWalletEnabled("apple-pay", true, "Ready");
				}
				// end of active card required condition  
			} else {
				var reason = "Apple Pay not found";
				_wallets_i4goTrueTokenObj.settings.debug && remoteLog(reason);
				_wallets_i4goTrueTokenObj.onWalletEnabled("apple-pay", false, reason);
			}
		} else {
			var reason = "Apple Pay not configured";
			_wallets_i4goTrueTokenObj.settings.debug && remoteLog(reason);
			_wallets_i4goTrueTokenObj.onWalletEnabled("apple-pay", false, reason);
		}
	} catch (e) {
		var reason = "applePayInit Error: " + e.message;
		console.error(reason, e);
		remoteLog(reason, false);
		_wallets_i4goTrueTokenObj.onWalletEnabled("apple-pay", false, reason);
	}
}

function onApplePayClick(e) {
	try {
		e.preventDefault();
		if (_wallets_canMakeApplePayments) {
			_wallets_i4goTrueTokenObj.clear();
			var applePayPaymentRequest = {
				countryCode: _wallets_i4goTrueTokenObj.walletConfig.countryCode,
				currencyCode: _wallets_i4goTrueTokenObj.walletConfig.currencyCode,
				supportedNetworks: _wallets_i4goTrueTokenObj.walletConfig.applePay.supportedNetworks,
				merchantCapabilities: ['supports3DS'],
				total: {
					label: 'total',
					amount: _wallets_i4goTrueTokenObj.basket.OrderDetails.Amount.toFixed(2)
				},
				/*
				        // OPTIONAL PAYMENT
				        requiredBillingContactFields: [ "email", "name", "phone", "postalAddress" ],
				*/
				requiredShippingContactFields: apGetRequiredShippingContactFields(),
				shippingMethods: apGetDefaultShippingMethods(),
				shippingType: _wallets_i4goTrueTokenObj.settings.wallet.shippingType
			};
			_wallets_i4goTrueTokenObj.settings.debug && remoteLog("onApplePayClick.applePayPaymentRequest: " + JSON.stringify(applePayPaymentRequest));

			var session = new ApplePaySession(3, applePayPaymentRequest);
			session.begin();

			/**
			 * Merchant Validation
			 * We call our merchant session endpoint, passing the URL to use
			 */
			session.onvalidatemerchant = function (event) {
				const validationURL = event.validationURL;
				getApplePaySession(validationURL).then(function (response) {
					session.completeMerchantValidation(response);
					session.onpaymentauthorized = function (event) {
						postApplePayToken(event.payment, session);
					}
					if (_wallets_i4goTrueTokenObj.settings.wallet.shippingOptionRequired) {
						session.onshippingcontactselected = function (event) { apOnShippingContactSelected(event, session); }
						session.onshippingmethodselected = function (event) { apOnShippingMethodSelected(event, session); }
					}
				}, function (error) {
					console.error("onApplePayClick.session.onvalidatemerchant.ERROR:" + error.message, error);
					remoteLog("onApplePayClick.session.onvalidatemerchant.ERROR: " + error.message, false);
				});
			};
		} else {
			alert("Cannot make payment.");
		}
	} catch (e) {
		console.error("onApplePayClick.ERROR:" + e.message, e);
		remoteLog("onApplePayClick.ERROR: " + e.message, false);
	}
}
/**
 * Server to Server call to apple for response used to validate *merchant
 */
function getApplePaySession(validationURL) {
	try {
		return new Promise(function (resolve, reject) {
			const url = "https://" + _wallets_i4goTrueTokenObj.walletConfig.providerDomain + "/index.cfm?fuseaction=ws.applePaySession";
			const data = {
				validationURL: validationURL,
				i4go_accessBlock: _wallets_i4goTrueTokenObj.settings.accessBlock
			};
			_wallets_i4goTrueTokenObj.settings.debug && remoteLog("Sending getApplePaySession: " + JSON.stringify({
				url: url,
				data: data
			}));
			$.post(url, data, function (responseData, status) {
				if (status == "success") {
					resolve(responseData);
				} else {
					_wallets_i4goTrueTokenObj.settings.debug && remoteLog("Failed getApplePaySession: " + JSON.stringify({
						url: url,
						responseData: responseData
					}));
					reject({
						status: status
					});
				}
			}).fail(function (jqXHR, textStatus, errorThrown) {
				_wallets_i4goTrueTokenObj.settings.debug && remoteLog("Failed getApplePaySession: " + JSON.stringify({
					url: url,
					jqXHR: jqXHR,
					textStatus: textStatus,
					errorThrown: errorThrown
				}));
				reject({
					status: textStatus
				});
			});
		});
	} catch (e) {
		console.error("onApplePayClick.ERROR:" + e.message, e);
		remoteLog("onApplePayClick.ERROR: " + e.message, false);
	}
}

function postApplePayToken(payment, session) {
	_wallets_i4goTrueTokenObj.settings.debug && remoteLog("Sending Apple payment token to i4go frame...");
	Object.assign(payment, {
		shippingIdentifier: currentShippingIdentifier
	}); // this is not contained in the default info from apple - weird
	_wallet_session = {
		wallet: "apple",
		session: session,
		payment: payment
	};
	_wallets_i4goTrueTokenObj.sendApplePayToFrame(payment);
	postWalletComplete(true); // short-circuited confirmation from iframe due to 3DS which may need the iframe dialog for cardholder challenge
}

function postApplePayComplete(success) {
	if (_wallet_session != null && _wallet_session.wallet == "apple") {
		var desc = "failure";
		if (success) {
			desc = "success";
		}
		_wallets_i4goTrueTokenObj.settings.debug && remoteLog("Apple Pay post complete: " + desc);
		if (success) {
			_wallet_session.session.completePayment(_wallet_session.session.STATUS_SUCCESS);
		} else {
			_wallet_session.session.completePayment(_wallet_session.session.STATUS_FAILURE);
		}
		_wallet_session = null;
	}
}

function apGetRequiredShippingContactFields() {
	let requiredShippingContactFields = [];
	if (_wallets_i4goTrueTokenObj.settings.wallet.emailRequired) {
		requiredShippingContactFields.push("email");
	}
	if (typeof _wallets_i4goTrueTokenObj.settings.wallet.nameRequired === "boolean" ? _wallets_i4goTrueTokenObj.settings.wallet.nameRequired : _wallets_i4goTrueTokenObj.settings.wallet.addressRequired) {
		requiredShippingContactFields.push("name");
	}
	if (_wallets_i4goTrueTokenObj.settings.wallet.phoneNumberRequired) {
		requiredShippingContactFields.push("phone");
	}
	if (_wallets_i4goTrueTokenObj.settings.wallet.addressRequired) {
		requiredShippingContactFields.push("postalAddress");
	}
	return requiredShippingContactFields;
}

function apGetDefaultShippingMethods() {
	let shippingMethods = [];
	if (typeof _wallets_i4goTrueTokenObj.settings.wallet.shippingOptions === "object") {
		_wallets_i4goTrueTokenObj.settings.wallet.shippingOptions.forEach(function (item) {
			shippingMethods.push({
				label: item.label,
				detail: item.description,
				amount: item.amount,
				identifier: item.id
			})
		});
	}
	return shippingMethods;
}

let currentShippingIdentifier = "";

function ap2gpIntermediatePaymentData(callbackTrigger, defaultShippingId, event) {
	let intermediatePaymentData = {
		callbackTrigger: callbackTrigger
	};
	if (typeof event.shippingContact === "object") {
		Object.assign(intermediatePaymentData, {
			shippingAddress: event.shippingContact,
			shippingOptionData: {
				id: defaultShippingId
			}
		});
		currentShippingIdentifier = defaultShippingId;
	};
	if (typeof event.shippingMethod === "object") {
		Object.assign(intermediatePaymentData, {
			shippingOptionData: {
				id: event.shippingMethod.identifier
			}
		});
		currentShippingIdentifier = event.shippingMethod.identifier;
	};
	return intermediatePaymentData;
}

function gp2apPaymentDataRequestUpdate(gpPaymentDataRequestUpdate) {
	let apPaymentDataRequestUpdate = {
		newTotal: {
			type: gpPaymentDataRequestUpdate.newTransactionInfo.totalPriceStatus.toLowerCase(),
			label: gpPaymentDataRequestUpdate.newTransactionInfo.totalPriceLabel,
			amount: gpPaymentDataRequestUpdate.newTransactionInfo.totalPrice
		},
		newLineItems: []
	};
	gpPaymentDataRequestUpdate.newTransactionInfo.displayItems.forEach(function (item) {
		apPaymentDataRequestUpdate.newLineItems.push({
			type: item.status.toLowerCase(),
			label: item.label,
			amount: item.price
		})
	});
	if (typeof gpPaymentDataRequestUpdate.newShippingOptionParameters === "object") {
		try {
			const regex = /^([\$]?(\d*([.,](?=\d{3}))?\d+)+((?!\2)[.,]\d\d)?|Free)[\s\:\-$]/i;
			let newShippingMethods = [];
			gpPaymentDataRequestUpdate.newShippingOptionParameters.shippingOptions.forEach(function (item) {
				let amount = "0.00";
				if (typeof item.price === "string") {
					amount = item.price;
				} else if (typeof item.price === "number") {
					amount = item.price.toFixed(2);
				}
				let label = $.trim(item.label.replace(regex, ""));
				newShippingMethods.push({
					label: label,
					detail: item.description,
					amount: amount,
					identifier: item.id
				});
			});
			Object.assign(apPaymentDataRequestUpdate, {
				newShippingMethods: newShippingMethods
			});
		} catch (e) {
			console.error("gp2apPaymentDataRequestUpdate.ERROR:" + e.message, e);
			remoteLog("gp2apPaymentDataRequestUpdate.ERROR: " + e.message, false);
		}
	}
	_wallets_i4goTrueTokenObj.settings.debug && remoteLog('gp2apPaymentDataRequestUpdate: {"gpPaymentDataRequestUpdate":' + JSON.stringify(gpPaymentDataRequestUpdate) + ',"apPaymentDataRequestUpdate":' + JSON.stringify(apPaymentDataRequestUpdate) + '}');


	/*
	GP update
	{
	  "newTransactionInfo": {
	    "displayItems": [
	      {
	        "label": "Subtotal",
	        "type": "SUBTOTAL",
	        "price": "44.44"
	      },
	      {
	        "type": "LINE_ITEM",
	        "label": "Shipping Cost",
	        "price": "2.99",
	        "status": "FINAL"
	      }
	    ],
	    "countryCode": "US",
	    "currencyCode": "USD",
	    "totalPriceStatus": "FINAL",
	    "totalPrice": "47.43",
	    "totalPriceLabel": "Total"
	  }

	  "newShippingOptionParameters": {
	    "defaultSelectedOptionId":"shipping-001",
	    "shippingOptions":[
	      {
	        "id":"shipping-001",
	        "label":"Free: Standard shipping",
	        "description":"Free shipping delivered in 5 business days; handling fees still apply."
	      },
	      {
	        "id":"shipping-002",
	        "label":"$2.99: Standard shipping",
	        "description":"Standard shipping delivered in 3 business days."
	      },
	      {
	        "id":"shipping-003",
	        "label":"$10: Express shipping",
	        "description":"Express shipping delivered in 1 business day."
	      },
	      {
	        "id":"shipping-004",
	        "label":"$1299: Hand delivered",
	        "description":"Hand delivered in 10-30 business days."
	      }
	    ]
	  }


	}

	AP update
	{
	  "newTotal": {
	    "type": "final",
	    "label": "Total",
	    "amount": "47.43"
	  },
	  "newLineItems": [
	    {
	      "type": "final",
	      "label": "Subtotal",
	      "amount": "44.44"
	    },
	    {
	      "type": "final",
	      "label": "Shipping Cost",
	      "amount": "2.99"
	    }
	  ]
	}
	*/
	return apPaymentDataRequestUpdate;
}

function apOnPaymentDataChanged(callbackTrigger, defaultShippingId, event, session) {
	_wallets_i4goTrueTokenObj.settings.debug && remoteLog("apOnPaymentDataChanged.begin: " + JSON.stringify(arguments));
	return new Promise(function (resolve, reject) {
		gpOnPaymentDataChanged(ap2gpIntermediatePaymentData(callbackTrigger, defaultShippingId, event), "apple")
			.then(function (paymentDataRequestUpdate) {
				let result = gp2apPaymentDataRequestUpdate(paymentDataRequestUpdate);
				_wallets_i4goTrueTokenObj.settings.debug && remoteLog("apOnPaymentDataChanged.end: " + JSON.stringify(result));
				resolve(result);
			})
			.catch(function (e) {
				console.error("apOnPaymentDataChanged.ERROR:" + e.message, e);
				remoteLog("apOnPaymentDataChanged.ERROR: " + e.message, false);
				reject(e);
			});
	});
}

function apOnShippingContactSelected(event, session) {
	let shippingContact = event.shippingContact;
	apOnPaymentDataChanged("SHIPPING_ADDRESS", _wallets_i4goTrueTokenObj.settings.wallet.shippingOptions[0].id, event, session)
		.then(function (paymentDataRequestUpdate) { session.completeShippingContactSelection(paymentDataRequestUpdate) })
		.catch(function (e) {
			console.error("apOnShippingContactSelected.ERROR:" + e.message, e);
			remoteLog("apOnShippingContactSelected.ERROR: " + e.message, false);
			throw (e);
		});
}

function apOnShippingMethodSelected(event, session) {
	let shippingMethod = event.shippingMethod;
	apOnPaymentDataChanged("SHIPPING_OPTION", shippingMethod.identifier, event, session)
		.then(function (paymentDataRequestUpdate) { session.completeShippingMethodSelection(paymentDataRequestUpdate) })
		.catch(function (e) {
			console.error("apOnShippingMethodSelected.ERROR:" + e.message, e);
			remoteLog("apOnShippingMethodSelected.ERROR: " + e.message, false);
			throw (e);
		});
}

/*
 **
 ** Google Pay
 **
 */

function googlePayInit(config) {
	try {
		_wallets_i4goTrueTokenObj.settings.debug && remoteLog("Checking for Google Pay...");
		_wallets_i4goTrueTokenObj.settings.debug && console.log("wallet - googlePayInit()", config);
		paymentsClient = null;
		if ((typeof config === "object") &&
			(typeof config.googlePay === "object") &&
			(typeof config.googlePay.authJwt === "string") &&
			config.googlePay.authJwt.length) {

			_wallets_i4goTrueTokenObj.settings.debug && remoteLog("Google Pay configuration found");
			tokenizationSpecification.parameters.gateway = config.googlePay.gateway;
			tokenizationSpecification.parameters.gatewayMerchantId = (typeof config.merchant === "object" && typeof config.merchant.identifier === "string") ? config.merchant.identifier : config.merchantID.toString();
			allowedCardAuthMethods = config.googlePay.allowedAuthMethods;
			allowedCardNetworks = config.googlePay.allowedCardNetworks;
			baseCardPaymentMethod.parameters.allowedAuthMethods = allowedCardAuthMethods;
			baseCardPaymentMethod.parameters.allowedCardNetworks = allowedCardNetworks;
			baseCardPaymentMethod.parameters = Object.assign(baseCardPaymentMethod.parameters, {
				allowedAuthMethods: allowedCardAuthMethods,
				allowedCardNetworks: allowedCardNetworks,
				billingAddressRequired: (typeof _wallets_i4goTrueTokenObj.settings.wallet.nameRequired === "boolean" ? _wallets_i4goTrueTokenObj.settings.wallet.nameRequired : _wallets_i4goTrueTokenObj.settings.wallet.addressRequired),
				billingAddressParameters: {
					format: "MIN",
					phoneNumberRequired: _wallets_i4goTrueTokenObj.settings.wallet.phoneNumberRequired
				}
			});
			cardPaymentMethod = Object.assign({},
				baseCardPaymentMethod, {
				tokenizationSpecification: tokenizationSpecification
			}
			);

			onGooglePayLoaded();

		} else {
			var reason = "Google Pay not configured";
			_wallets_i4goTrueTokenObj.settings.debug && remoteLog(reason);
			_wallets_i4goTrueTokenObj.onWalletEnabled("google-pay", false, reason);
		}
	} catch (e) {

		var reason = "googlePayInit Error: " + e.message;
		console.error(reason, e);
		remoteLog(reason, false);
		_wallets_i4goTrueTokenObj.onWalletEnabled("google-pay", false, reason);

	}
}

/**
 * Define the version of the Google Pay API referenced when creating your
 * configuration
 *
 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#PaymentDataRequest|apiVersion in PaymentDataRequest}
 */
const baseRequest = {
	apiVersion: 2,
	apiVersionMinor: 0
};

/**
 * Card networks supported by your site and your gateway
 *
 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#CardParameters|CardParameters}
 * @todo confirm card networks supported by your site and gateway
 */
let allowedCardNetworks = ["AMEX", "DISCOVER", "JCB", "MASTERCARD", "VISA"];

/**
 * Card authentication methods supported by your site and your gateway
 *
 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#CardParameters|CardParameters}
 * @todo confirm your processor supports Android device tokens for your
 * supported card networks
 */
let allowedCardAuthMethods = ["PAN_ONLY", "CRYPTOGRAM_3DS"];

/**
 * Identify your gateway and your site's gateway merchant identifier
 *
 * The Google Pay API response will return an encrypted payment method capable
 * of being charged by a supported gateway after payer authorization
 *
 * @todo check with your gateway on the parameters to pass
 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#gateway|PaymentMethodTokenizationSpecification}
 */
let tokenizationSpecification = {
	type: 'PAYMENT_GATEWAY',
	parameters: {
		'gateway': 'shift4',
		'gatewayMerchantId': ''
	}
};

/**
 * Describe your site's support for the CARD payment method and its required
 * fields
 *
 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#CardParameters|CardParameters}
 */
let baseCardPaymentMethod = {
	type: 'CARD',
	parameters: {
		allowedAuthMethods: allowedCardAuthMethods,
		allowedCardNetworks: allowedCardNetworks
	}
};

/**
 * Describe your site's support for the CARD payment method including optional
 * fields
 *
 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#CardParameters|CardParameters}
 */
let cardPaymentMethod = Object.assign({},
	baseCardPaymentMethod, {
	tokenizationSpecification: tokenizationSpecification
}
);

/**
 * An initialized google.payments.api.PaymentsClient object or null if not yet set
 *
 * @see {@link getGooglePaymentsClient}
 */
let paymentsClient = null;

/**
 * Configure your site's support for payment methods supported by the Google Pay
 * API.
 *
 * Each member of allowedPaymentMethods should contain only the required fields,
 * allowing reuse of this base request when determining a viewer's ability
 * to pay and later requesting a supported payment method
 *
 * @returns {object} Google Pay API version, payment methods supported by the site
 */
function getGoogleIsReadyToPayRequest() {
	return Object.assign({},
		baseRequest, {
		allowedPaymentMethods: [baseCardPaymentMethod]
	}
	);
}

/**
 * Configure support for the Google Pay API
 *
 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#PaymentDataRequest|PaymentDataRequest}
 * @returns {object} PaymentDataRequest fields
 */
function getGooglePaymentDataRequest() {
	try {
		const paymentDataRequest = Object.assign({}, baseRequest);
		paymentDataRequest.allowedPaymentMethods = [cardPaymentMethod];
		paymentDataRequest.transactionInfo = getGoogleTransactionInfo();
		paymentDataRequest.merchantInfo = {
			merchantId: _wallets_i4goTrueTokenObj.walletConfig.googlePay.merchantId,
			merchantName: _wallets_i4goTrueTokenObj.walletConfig.merchantName.length ? _wallets_i4goTrueTokenObj.walletConfig.merchantName : "Merchant",
			merchantOrigin: _wallets_i4goTrueTokenObj.walletConfig.googlePay.merchantDomain,
			authJwt: _wallets_i4goTrueTokenObj.walletConfig.googlePay.authJwt
		};

		let callbackIntents = ["PAYMENT_AUTHORIZATION"];
		if (_wallets_i4goTrueTokenObj.settings.wallet.shippingOptionRequired) {
			callbackIntents = ["SHIPPING_ADDRESS", "SHIPPING_OPTION", "PAYMENT_AUTHORIZATION"];
		}
		paymentDataRequest.callbackIntents = callbackIntents;
		paymentDataRequest.emailRequired = _wallets_i4goTrueTokenObj.settings.wallet.emailRequired;
		paymentDataRequest.shippingAddressRequired = _wallets_i4goTrueTokenObj.settings.wallet.addressRequired;
		paymentDataRequest.shippingAddressParameters = getGoogleShippingAddressParameters();
		paymentDataRequest.shippingOptionRequired = _wallets_i4goTrueTokenObj.settings.wallet.shippingOptionRequired;
		return paymentDataRequest;
	} catch (e) {
		let errmsg = 'getGooglePaymentDataRequest.ERROR: {"error":"' + e.message + '"}';
		remoteLog(errmsg, false);
		console.error(errmsg);
		throw (e);
	}
}

/**
 * Return an active PaymentsClient or initialize
 *
 * @see {@link https://developers.google.com/pay/api/web/reference/client#PaymentsClient|PaymentsClient constructor}
 * @returns {google.payments.api.PaymentsClient} Google Pay API client
 */
function getGooglePaymentsClient() {
	try {
		if (paymentsClient === null) {
			let paymentDataCallbacks = {
				onPaymentAuthorized: gpOnPaymentAuthorized
			}
			if (_wallets_i4goTrueTokenObj.settings.wallet.shippingOptionRequired) {
				paymentDataCallbacks = {
					onPaymentDataChanged: gpOnPaymentDataChanged,
					onPaymentAuthorized: gpOnPaymentAuthorized
				};
			}
			paymentsClient = new google.payments.api.PaymentsClient({
				environment: _wallets_i4goTrueTokenObj.walletConfig.googlePay.environment,
				merchantInfo: {
					merchantId: _wallets_i4goTrueTokenObj.walletConfig.googlePay.merchantId,
					merchantName: _wallets_i4goTrueTokenObj.walletConfig.merchantName.length ? _wallets_i4goTrueTokenObj.walletConfig.merchantName : "Merchant",
					merchantOrigin: _wallets_i4goTrueTokenObj.walletConfig.googlePay.merchantDomain,
					authJwt: _wallets_i4goTrueTokenObj.walletConfig.googlePay.authJwt
				},
				paymentDataCallbacks: paymentDataCallbacks
			});
		}
		return paymentsClient;
	} catch (e) {
		let errmsg = 'getGooglePaymentsClient.ERROR: {"error":"' + e.message + '"}';
		remoteLog(errmsg, false);
		console.error(errmsg);
		throw (e);
	}
}


function gpOnPaymentAuthorized(paymentData) {
	return new Promise(function (resolve, reject) {
		// handle the response
		processPayment(paymentData)
			.then(function () {
				resolve({
					transactionState: 'SUCCESS'
				});
			})
			.catch(function () {
				resolve({
					transactionState: 'ERROR',
					error: {
						intent: 'PAYMENT_AUTHORIZATION',
						message: 'Invalid payment data',
						reason: 'PAYMENT_DATA_INVALID'
					}
				});
			});

	});
}

/**
 * Handles dynamic buy flow shipping address and shipping options callback intents.
 *
 * @param {object} itermediatePaymentData response from Google Pay API a shipping address or shipping option is selected in the payment sheet.
 * @see {@link https://developers.google.com/pay/api/web/reference/response-objects#IntermediatePaymentData|IntermediatePaymentData object reference}
 *
 * @see {@link https://developers.google.com/pay/api/web/reference/response-objects#PaymentDataRequestUpdate|PaymentDataRequestUpdate}
 * @returns Promise<{object}> Promise of PaymentDataRequestUpdate object to update the payment sheet.
 */
function gpOnPaymentDataChanged(intermediatePaymentData, wallet) {
	return new Promise(function (resolve, reject) {
		try {
			let shippingAddress = intermediatePaymentData.shippingAddress;
			let shippingOptionData = intermediatePaymentData.shippingOptionData;
			let paymentDataRequestUpdate = {};
			if (intermediatePaymentData.callbackTrigger == "INITIALIZE" || intermediatePaymentData.callbackTrigger == "SHIPPING_ADDRESS") {
				paymentDataRequestUpdate.newShippingOptionParameters = getDefaultShippingOptions();
				let selectedShippingOptionId = paymentDataRequestUpdate.newShippingOptionParameters.defaultSelectedOptionId;
				paymentDataRequestUpdate.newTransactionInfo = calculateNewTransactionInfo(selectedShippingOptionId);
			} else if (intermediatePaymentData.callbackTrigger == "SHIPPING_OPTION") {
				paymentDataRequestUpdate.newTransactionInfo = calculateNewTransactionInfo(shippingOptionData.id);
			}
			if (typeof _wallets_i4goTrueTokenObj.settings.onPaymentDataChanged === "function") {
				paymentDataRequestUpdate = _wallets_i4goTrueTokenObj.settings.onPaymentDataChanged(_wallets_i4goTrueTokenObj, intermediatePaymentData, paymentDataRequestUpdate);
			}
			_wallets_i4goTrueTokenObj.settings.debug && remoteLog('gpOnPaymentDataChanged.callout: {"intermediatePaymentData":' + JSON.stringify(intermediatePaymentData) + ',"paymentDataRequestUpdate":' + JSON.stringify(paymentDataRequestUpdate) + '}');
			if (typeof wallet !== "string" || wallet === "google") {
				if (typeof paymentDataRequestUpdate.newShippingOptionParameters === "object") {
					paymentDataRequestUpdate.newShippingOptionParameters.shippingOptions = getGoogleShippingOptions(paymentDataRequestUpdate.newShippingOptionParameters.shippingOptions);
				}
			}
			resolve(paymentDataRequestUpdate);
		} catch (e) {
			let errmsg = 'gpOnPaymentDataChanged.callout.ERROR: {"error":"' + e.message + '","intermediatePaymentData":' + JSON.stringify(intermediatePaymentData) + ',"paymentDataRequestUpdate":' + JSON.stringify(paymentDataRequestUpdate) + '}';
			remoteLog(errmsg, false);
			console.error(errmsg);
			reject(e);
		}
	});
}

/**
 * Helper function to create a new TransactionInfo object.
 
 * @param string shippingOptionId respresenting the selected shipping option in the payment sheet.
 *
 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#TransactionInfo|TransactionInfo}
 * @returns {object} transaction info, suitable for use as transactionInfo property of PaymentDataRequest
 */
function calculateNewTransactionInfo(shippingOptionId) {
	try {
		let newTransactionInfo = getGoogleTransactionInfo();
		if (_wallets_i4goTrueTokenObj.settings.wallet.shippingOptionRequired) {
			let shippingCost = getDefaultShippingCost(shippingOptionId);
			newTransactionInfo.displayItems.push({
				type: "LINE_ITEM",
				label: "Shipping Cost",
				price: shippingCost.toFixed(2),
				status: "FINAL"
			});
			let totalPrice = 0.00;
			newTransactionInfo.displayItems.forEach(function (displayItem) { totalPrice += parseFloat(displayItem.price) });
			newTransactionInfo.totalPrice = totalPrice.toFixed(2);
		}
		return newTransactionInfo;
	} catch (e) {
		let errmsg = "calculateNewTransactionInfo.ERROR:" + e.message;
		console.error(errmsg);
		remoteLog(errmsg, false);
		throw (e);
	}
}

/**
 * Initialize Google PaymentsClient after Google-hosted JavaScript has loaded
 *
 * Display a Google Pay payment button after confirmation of the viewer's
 * ability to pay.
 */
function onGooglePayLoaded() {
	const paymentsClient = getGooglePaymentsClient();
	paymentsClient.isReadyToPay(getGoogleIsReadyToPayRequest()).then(function (response) {
		_wallets_i4goTrueTokenObj.settings.debug && remoteLog("onGooglePayLoaded.response: " + JSON.stringify(response));
		if (response.result) {
			addGooglePayButton();
			_wallets_i4goTrueTokenObj.onWalletEnabled("google-pay", true, "Ready");
		} else {
			_wallets_i4goTrueTokenObj.onWalletEnabled("google-pay", false, "Google Pay not available");
		}
	}).catch(function (error) {     // show error in developer console for debugging
		var reason = "getGoogleIsReadyToPayRequest.ERROR: " + error.message;
		console.error(reason, error);
		remoteLog(reason, false);
		_wallets_i4goTrueTokenObj.onWalletEnabled("google-pay", false, reason);
	});
}

/**
 * Add a Google Pay purchase button alongside an existing checkout button
 *
 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#ButtonOptions|Button options}
 * @see {@link https://developers.google.com/pay/api/web/guides/brand-guidelines|Google Pay brand guidelines}
 */
function addGooglePayButton() {
	const paymentsClient = getGooglePaymentsClient();
	let buttonOptions = {
		onClick: onGooglePaymentButtonClicked
	};
	if (typeof _wallets_i4goTrueTokenObj.settings.wallet.buttonColor === "string") {
		Object.assign(buttonOptions, {
			buttonColor: _wallets_i4goTrueTokenObj.settings.wallet.buttonColor
		});
	}
	if (typeof _wallets_i4goTrueTokenObj.settings.wallet.buttonType === "string") {
		Object.assign(buttonOptions, {
			buttonType: _wallets_i4goTrueTokenObj.settings.wallet.buttonType
		});
	}
	if (typeof _wallets_i4goTrueTokenObj.settings.wallet.buttonSizeMode === "string") {
		Object.assign(buttonOptions, {
			buttonSizeMode: _wallets_i4goTrueTokenObj.settings.wallet.buttonSizeMode
		});
	}
	if (typeof _wallets_i4goTrueTokenObj.settings.wallet.buttonRootNode === "string") {
		Object.assign(buttonOptions, {
			buttonRootNode: _wallets_i4goTrueTokenObj.settings.wallet.buttonRootNode
		});
	}
	const button = paymentsClient.createButton(buttonOptions);

	var $buttonObj = $(button).find("button");
	if ($buttonObj.length === 0) {
		$buttonObj = $(button);
	}
	$buttonObj.addClass("pay-button google-pay-button");
	$(".google-pay-button").replaceWith(button);
	$(".google-pay-button").show().removeClass("hidden").removeClass("pay-hidden");
}

/**
 * Provide Google Pay API with a payment amount, currency, and amount status
 *
 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#TransactionInfo|TransactionInfo}
 * @returns {object} transaction info, suitable for use as transactionInfo property of PaymentDataRequest
 */
function getGoogleTransactionInfo() {
	try {
		let result = {
			displayItems: [],
			countryCode: _wallets_i4goTrueTokenObj.walletConfig.countryCode,
			currencyCode: _wallets_i4goTrueTokenObj.walletConfig.currencyCode,
			totalPriceStatus: "FINAL",
			totalPrice: _wallets_i4goTrueTokenObj.basket.OrderDetails.Amount.toFixed(2),
			totalPriceLabel: "Total"
		};
		if (typeof _wallets_i4goTrueTokenObj.basket.Cart === "object" && _wallets_i4goTrueTokenObj.basket.Cart.length > 0) {
			_wallets_i4goTrueTokenObj.basket.Cart.forEach(function (item) {
				result.displayItems.push({
					label: item.Name,
					type: "LINE_ITEM",
					price: item.Price.toFixed(2)
				})
			});
		} else {
			result.displayItems.push({
				label: "Subtotal",
				type: "SUBTOTAL",
				price: _wallets_i4goTrueTokenObj.basket.OrderDetails.Amount.toFixed(2)
			});
		}
		return result;
	} catch (e) {
		let errmsg = "getGoogleTransactionInfo.ERROR:" + e.message;
		console.error(errmsg);
		remoteLog(errmsg, false);
		throw (e);
	}
}

/**
 * Provide a key value store for shippping options.
 */
function getDefaultShippingCost(id) {
	try {
		let amount = 0.00;
		for (let i = 0; i < _wallets_i4goTrueTokenObj.settings.wallet.shippingOptions.length; i++) {
			if (_wallets_i4goTrueTokenObj.settings.wallet.shippingOptions[i].id === id) {
				amount = _wallets_i4goTrueTokenObj.settings.wallet.shippingOptions[i].amount;
				break;
			}
		}
		return amount;
	} catch (e) {
		let errmsg = "getDefaultShippingCost.ERROR:" + e.message;
		console.error(errmsg);
		remoteLog(errmsg, false);
		throw (e);
	}
}

/**
 * Provide Google Pay API with billing address parameters when using dynamic buy flow.
 *
 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#BillingAddressParameters|BillingAddressParameters}
 * @returns {object} shipping address details, suitable for use as billingAddressParameters property of PaymentDataRequest
 */
function getGoogleBillingAddressParameters() {
	return {
		format: "MIN"
	};
}

/**
 * Provide Google Pay API with shipping address parameters when using dynamic buy flow.
 *
 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#ShippingAddressParameters|ShippingAddressParameters}
 * @returns {object} shipping address details, suitable for use as shippingAddressParameters property of PaymentDataRequest
 */
function getGoogleShippingAddressParameters() {
	return {
		allowedCountryCodes: _wallets_i4goTrueTokenObj.settings.wallet.allowedCountryCodes,
		phoneNumberRequired: _wallets_i4goTrueTokenObj.settings.wallet.phoneNumberRequired
	};
}

/**
 * Provide Google Pay API with shipping options and a default selected shipping option.
 *
 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#ShippingOptionParameters|ShippingOptionParameters}
 * @returns {object} shipping option parameters, suitable for use as shippingOptionParameters property of PaymentDataRequest
 */
function getGoogleShippingOptions(shippingOptions) {
	let result = [];
	shippingOptions.forEach(function (item) {
		result.push({
			id: item.id,
			label: item.label,
			description: item.description
		})
	});
	return result;
}

function getDefaultShippingOptions() {
	let shippingOptions = [];
	_wallets_i4goTrueTokenObj.settings.wallet.shippingOptions.forEach(function (item) { shippingOptions.push(item) });
	/*
	_wallets_i4goTrueTokenObj.settings.wallet.shippingOptions.forEach(item => shippingOptions.push({
	  id: item.id,
	  label: item.label,
	  description: item.description
	}) );
	*/
	return {
		defaultSelectedOptionId: shippingOptions[0].id,
		shippingOptions: shippingOptions
	};
}

/**
 * Provide Google Pay API with a payment data error.
 *
 * @see {@link https://developers.google.com/pay/api/web/reference/response-objects#PaymentDataError|PaymentDataError}
 * @returns {object} payment data error, suitable for use as error property of PaymentDataRequestUpdate
 */
function getGoogleUnserviceableAddressError() {
	console.warn("getGoogleUnserviceableAddressError() called!")
	return {
		reason: "SHIPPING_ADDRESS_UNSERVICEABLE",
		message: "Cannot ship to the selected address",
		intent: "SHIPPING_ADDRESS"
	};
}

/**
 * Prefetch payment data to improve performance
 *
 * @see {@link https://developers.google.com/pay/api/web/reference/client#prefetchPaymentData|prefetchPaymentData()}
 */
function prefetchGooglePaymentData() {
	const paymentDataRequest = getGooglePaymentDataRequest();
	// transactionInfo must be set but does not affect cache
	paymentDataRequest.transactionInfo = {
		totalPriceStatus: 'NOT_CURRENTLY_KNOWN',
		currencyCode: 'USD'
	};
	const paymentsClient = getGooglePaymentsClient();
	paymentsClient.prefetchPaymentData(paymentDataRequest);
}


/**
 * Show Google Pay payment sheet when Google Pay payment button is clicked
 */
function onGooglePaymentButtonClicked() {
	const paymentDataRequest = getGooglePaymentDataRequest();
	paymentDataRequest.transactionInfo = getGoogleTransactionInfo();

	const paymentsClient = getGooglePaymentsClient();

    _wallets_i4goTrueTokenObj.settings.wallet.paymentInitiatedEvent();

	paymentsClient.loadPaymentData(paymentDataRequest)
		.catch(error => _wallets_i4goTrueTokenObj.settings.wallet.paymentErrorEvent(error));
}

/**
 * Process payment data returned by the Google Pay API
 *
 * @param {object} paymentData response from Google Pay API after user approves payment
 * @see {@link https://developers.google.com/pay/api/web/reference/response-objects#PaymentData|PaymentData object reference}
 */
function processPayment(paymentData) {
	_wallets_i4goTrueTokenObj.settings.debug && remoteLog("Sending Google payment token to i4go frame...");
	console.log("GP", paymentData);
	_wallet_session = {
		wallet: "google",
		session: null,
		payment: paymentData
	};
	_wallets_i4goTrueTokenObj.sendGooglePayToFrame(paymentData);
	postWalletComplete(true); // short-circuited confirmation from iframe due to 3DS which may need the iframe dialog for cardholder challenge
	return new Promise(function (resolve, reject) {
		var responseCountdown = 45 * 4; // 45 seconds
		var timerHandle = setInterval(function () {
			if (_wallet_session == null || _wallet_session.wallet != "google") {
				// something cleared or overwrote the wallet session
				clearInterval(timerHandle);
				reject({});
				_wallet_session = null;
			} else if (_wallet_session.success == null) {
				if (--responseCountdown <= 0) {
					// timeout
					clearInterval(timerHandle);
					reject({});
					_wallet_session = null;
				}
			} else {
				// complete
				clearInterval(timerHandle);
				if (_wallet_session.success) {
					resolve({});
				} else {
					reject({});
				}
				_wallet_session = null;
			}
		}, 250);
	});
}

function postGooglePayComplete(success) {
	// nothing to do, _wallet_session.success should have already been set
	var desc = "failure";
	if (success) {
		desc = "success";
	}
	_wallets_i4goTrueTokenObj.settings.debug && remoteLog("Google Pay post complete: " + desc);
}